export const QUICK_FIND_RECENT_ACTIVITIES_CACHE_KEY = 'quick-find-recent-activities';
